var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#827c78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.359 14.358c-.264-.757-.86-1.353-1.618-1.617V2h-1.763v10.74c-1.371.478-2.095 1.977-1.618 3.348.264.758.86 1.354 1.618 1.618v3.688h1.763v-3.688c1.371-.478 2.095-1.977 1.618-3.348zm-2.5 1.747c-.486 0-.881-.395-.881-.882s.395-.881.882-.881c.486 0 .881.394.881.881s-.395.882-.881.882zM7.254 14.358c-.264-.757-.86-1.353-1.618-1.617V2H3.873v10.74c-1.37.478-2.095 1.977-1.617 3.348.264.758.86 1.354 1.617 1.618v3.688h1.763v-3.688c1.371-.478 2.096-1.977 1.618-3.348zm-2.5 1.747c-.486 0-.88-.395-.88-.882s.394-.881.88-.881c.488 0 .882.394.882.881s-.394.882-.881.882zM14.306 9.07c-.264-.759-.86-1.355-1.617-1.619V2h-1.763v5.451C9.555 7.93 8.83 9.428 9.308 10.8c.264.757.86 1.353 1.618 1.617v8.978h1.763v-8.978c1.37-.477 2.095-1.976 1.617-3.347zm-2.499 1.745c-.487 0-.881-.394-.881-.881s.394-.882.881-.882.882.395.882.882-.395.881-.882.881z",
    transform: "rotate(90 12.5 12.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.f09ad1f3a16c33245181379ee90921c2.svg";
export { ForwardRef as ReactComponent };